import { render, staticRenderFns } from "./KeyGoalsBlock.vue?vue&type=template&id=038afcac&"
import script from "./KeyGoalsBlock.vue?vue&type=script&lang=js&"
export * from "./KeyGoalsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports